import { createFileRoute } from '@tanstack/react-router';

import { ProtectedRoute } from '@/components';
import OrdersDashboard from '@/pages/OrdersDashboard';

export const Route = createFileRoute('/commandes')({
  component: () => (
    <ProtectedRoute>
      <OrdersDashboard />
    </ProtectedRoute>
  ),
});
